import { consumeContext } from "@/lib/consume/context"
import { LoadingContext } from "@/lib/loading/context"

export const consumeLoading = consumeContext({
  Context: LoadingContext,
  provideTo: `loading`,
})
